import React, { useEffect, useState } from "react";
import AccountCategory from "./AccountCategory";
import ClinicAddress from "./ClinicAddress";
import Compliances from "./Compliances";
import EmailInfo from "./Email";
import Payment from "./Payment";
import PersonalInfo from "./PersonalInfo";
import PrimaryDetails from "./PrimaryDetails";
import { useFormik } from "formik";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  addDoctor,
  fetchDoctors,
} from "../../../../redux/Thunk/Doctor/DoctorThunks";
import { UserCreateMenu } from "../../../../utils/constants";
import SelectedTab from "../../../common/SelectedTab";
import {
  createDoctorValidation,
  upiValidation,
} from "../../../common/Validation/createOrderValidation";
import toast from "react-hot-toast";
import Loader from "../../../Loader";

const NewDoctor = ({ setDoctorForm }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector(
    ({ doctor }) => ({
      loading: doctor?.loading,
    }),
    shallowEqual
  );
  const [selectedOption, setSelectedOption] = useState("bank");

  const handleSubmit = async () => {
    const doctorData = formik?.values;
    if (!doctorData.doctorDetails.DID) {
      delete doctorData.doctorDetails.DID;
    }

    try {
      const response = await dispatch(addDoctor(doctorData)).unwrap();
      if (response.status === 200 || response.status === 201) {
        formik.resetForm();
      } else {
        if (response?.response?.data?.error) {
          if (
            response?.response?.data?.error === "Contact number already exists"
          ) {
            handleFocus("phone");
          } else if (
            response?.response?.data?.error ===
            "Gst number already exist in the system."
          ) {
            handleFocus("gst");
          }
          toast.error(response?.response?.data?.error);
        } else {
          toast.error(
            response?.error
              ? response?.error
              : "Something went wrong..please try after some time"
          );
        }
      }
    } catch (error) {
      console.error("Error creating doctor:", error);
      // toast.error("An error occurred while creating the account.");
    }
  };
  const handleFocus = (feild) => {
    if (feild === "phone") {
      const inputField = document.getElementById("contactNumber");
      inputField?.focus();
    } else if (feild === "gst") {
      const inputField = document.getElementById("compliances.gstNumber");
      inputField?.focus();
    }
  };

  const formik = useFormik({
    initialValues: {
      doctorDetails: {
        DID: "",
        contactNumber: "",
        pin: "",
        pinB: "",
      },
      compliances: {
        gstNumber: "",
        registrationNumber: "",
      },
      accountCategory: {
        category: "",
      },
      personalInfo: {
        name: "",
        surname: "",
        clinicName: "",
        tagline: "",
        qualificationSpecialisation: "",
        experience: "",
        operatorName: "",
        managerName: "",
        about1: "",
        about2: "",
      },
      clinicAddress: {
        premisesNo: "",
        floor: "",
        premisesName: "",
        landmark: "",
        areaRoad: "",
        city: "",
        pinCode: "",
        state: "",
        clinicContactNumber: "",
        googleMapUrl: "",
      },
      emailInfo: {
        doctorEmail: "",
        clinicEmail: "",
      },
      paymentDetails: {
        bankAccountNumber: "",
        accountName: "",
        bankName: "",
        ifscName: "",
        upiId: "",
      },
    },
    validationSchema:
      selectedOption === "bank" ? createDoctorValidation : upiValidation,
    onSubmit: handleSubmit,
    context: { paymentMethod: "bank" },
    validateOnChange: true,
  });

  useEffect(() => {
    dispatch(fetchDoctors());
  }, [dispatch]);

  return (
    <>
      <SelectedTab tabs={UserCreateMenu} index={1} />
      <Loader loading={loading} />
      <section className="tab-doctor">
        <form className="dashboard-container" onSubmit={formik.handleSubmit}>
          <div className="bg-gray-100 py-3 px-5 rounded-[12px]">
            <span className="pb-4 font-poppins font-medium text-[25px] leading-[30px]">
              Create Doctor Account
            </span>
            <PrimaryDetails formik={formik} handleFocus={handleFocus} />
            <Compliances formik={formik} />
            <AccountCategory formik={formik} />
            <PersonalInfo formik={formik} />
            <ClinicAddress formik={formik} />
            <EmailInfo formik={formik} />
            <Payment
              formik={formik}
              isCreateAccount={true}
              setDoctorForm={setDoctorForm}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
            />
          </div>
        </form>
      </section>
    </>
  );
};

export default NewDoctor;
